<!-- 产品模板 -->
<template>
    <div class="container">
        <div class="header">
            <Select class="w200 mr-24 mb-24" v-model="storePrams.industry_id" clearable filterable placeholder="请选择行业">
                <Option v-for="item in industryList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <Table :columns="columnTable" :data="dataTable" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="cover_img">
                    <div class="flex-c">
                        <div class="tooltip_div">
                            <Tooltip v-if="row.cover_img" theme="light" transfer>
                                <img class="cursor-p width_37_54" :src="row.cover_img"/>
                                <template slot="content">
                                    <img class="width_200_375" :src="row.cover_img"/>
                                </template>
                            </Tooltip>
                        </div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="industry">
                    <div>{{row.industry ? row.industry.name : ''}}</div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost label="small" @click="goCopy(row)">复制</Button>
                    </div>
                </template>
            </Table>
            <div class="ta-r mt-24">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total"  show-elevator show-total @on-change="pageChange"/>
            </div>
            <!-- 复制模板 -->
            <Modal v-model="copyModal" title="复制模板" width="40" :mask-closable="false">
                <div>
                    <Form :model="formItem" label-position="right" :label-width="100">
                        <FormItem label="模板名称：">
                            <Input class="width_15" type="text" v-model="formItem.title" placeholder="请输入模板名称"></Input>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                                <div slot="content"><p>此模板将会复制到DIY模板内！</p></div>
                            </Tooltip>
                        </FormItem>
                    </Form> 
                </div>
                <div slot="footer">
                    <Button @click="cancelCopyModal">取消</Button>
                    <Button class="theme-bg" type="warning" @click="submitCopyModal">确定</Button>
                </div>
            </Modal>
        </div>
    </div>
</template>

<script>
import { 
    template_result_template,
    template_copy_result,
} from '@/api/index';
import { other_industry_list } from '@/api/select';
import VueQr from 'vue-qr'
export default {
    components: { VueQr },
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                industry_id: -1,
            },
            total: 0,
            columnTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "预览图", slot: "cover_img", align: "center" },
                { title: "所属行业", slot: "industry", align: "center" },
                { title: "创建时间", key: "handle_time", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            copyModal: false,
            industryList: [],
            formItem: { 
                title: "",
                id: "",
            },
        };
    },
    mounted() {
        this.dataTable = [];
        this.getIndustryList();
        this.getList();
    },
    methods: {
        getList() {
            template_result_template(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // Page @on-change
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 搜索
        goSearch() {
            this.getList();
        },
        // 行业下拉
        getIndustryList() {
            other_industry_list().then((res) => {
                this.industryList = res.data;
            })
        },
        goCopy(row) {
            this.formItem.id = row.id;
            this.formItem.title = row.title;
            this.copyModal = true;
        },
        // 取消
        cancelCopyModal() {
            this.copyModal = false;
        },
        // 确定
        submitCopyModal() {
            template_copy_result(this.formItem).then((res) => {
                this.getList();
                this.copyModal = false;
                this.$Message.success(res.msg);
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.width_37_54 {
    width: 37px;
    height: 54px;
}
.width_200_375 {
    width: 200px;
    height: 375px;
}
.tooltip_div {
    margin: 12px;
    padding-top: 3px;
    width: 60px;
    height: 60px;
    background: #fbfbfb;
    border: 1px solid #eaeaea;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_15 {
    width: 15vw;
}
::v-deep .ivu-form-item {
    margin-bottom: 0;
}
</style>